import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['lowSeatsBanner', 'seatsLeft', 'progressBar', 'addSeatsBtn'];
  static values = { totalSeats: Number, singleLearner: Boolean, companyId: Number, jwtToken: String, apiUrl: String };

  connect() {
    this.isLearnerTrainingModal = $('#l-t-modal').find('.learners-select').length > 0;
    this.initializeListeners();
    if (this.hasSeatsLeftTarget) {
      this.seatsLeftTarget.textContent = this.totalSeatsValue || 0;
    }
    if (this.isLearnerTrainingModal) {
      setTimeout(() => this.checkSeatsAvailability(), 100);
    } else {
      this.checkSeatsAvailability();
    }
  }

  disconnect() {
    if (this.isLearnerTrainingModal) {
      $('#l-t-modal').find('.learners-select').off('select2:select.licensesController select2:unselect.licensesController');
    } else {
      $(document).off('change.licensesController');
      $(this.element).off('click.licensesController');
    }
  }

  initializeListeners() {
    if (this.isLearnerTrainingModal) {
      $('#l-t-modal').find('.learners-select').on('select2:select.licensesController select2:unselect.licensesController', () => {
        this.checkSeatsAvailability();
      });
    } else {
      $(document).on('change.licensesController', 'input[name="learner[learner_ids][]"].learner-checkbox', () => {
        this.checkSeatsAvailability();
      });
      $(this.element).on('click.licensesController', 'input[data-learners-target="courseCheckbox"]', () => {
        setTimeout(() => this.checkSeatsAvailability(), 150);
      });
    }
  }

  getSelectedLearnerIds() {
    if (this.isLearnerTrainingModal) {
      const val = $('#l-t-modal').find('.learners-select').val();
      return val || [];
    }
    if (this.singleLearnerValue) {
      const learnerId = this.element.dataset.learnerId;
      return learnerId ? [learnerId] : [];
    }
    return $('input[name="learner[learner_ids][]"].learner-checkbox:checked')
      .map((_, el) => el.value)
      .get();
  }

  getSelectedTrainingIds() {
    if (this.isLearnerTrainingModal) {
      const hiddenField = $('#l-t-modal').find('input[name="learner_training[training_ids][]"]');
      if (hiddenField.length) {
        const val = hiddenField.val();
        if (val) {
          const parsed = parseInt(val, 10);
          return !isNaN(parsed) ? [parsed] : [];
        }
      }
      const modalElement = document.getElementById('l-t-modal');
      if (modalElement) {
        const trainingId = modalElement.dataset.trainingId;
        if (trainingId) {
          const parsed = parseInt(trainingId, 10);
          return !isNaN(parsed) ? [parsed] : [];
        }
      }
    }
    return [];
  }

  redirectToAddSeats(event) {
    event.preventDefault();
    const btn = event.currentTarget;
    btn.classList.add('disabled');
    btn.textContent = 'Please wait...';
    localStorage.setItem('addSeatsReturnUrl', window.location.href.split('?')[0]);

    const finalize = () => {
      const overconsumedSeats = this.overconsumedSeats || 0;
      const url = new URL(btn.href);
      url.searchParams.set('seats', overconsumedSeats);
      window.location.href = url.toString();
    };

    const url = new URL(`/api/companies/${this.companyIdValue}/tracking/events`, this.apiUrlValue).toString();

    fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.jwtTokenValue}`
      },
      body: JSON.stringify({ event_name: 'subscription.addSeats_clicked' })
    }).finally(() => {
      finalize();
    });
  }

  async checkSeatsAvailability() {
    const learnerIds = this.getSelectedLearnerIds();
    const trainingIds = this.getSelectedTrainingIds();
    if (learnerIds.length === 0 || trainingIds.length === 0) {
      this.updateBannerState(false, 0);
      return;
    }
    const companyId = this.companyIdValue;
    if (!companyId) {
      this.updateBannerState(false, 0);
      return;
    }
    try {
      const response = await fetch(`/companies/${companyId}/low_balance`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
        },
        body: JSON.stringify({ learner_ids: learnerIds, training_ids: trainingIds, company_id: companyId })
      });
      if (response.ok) {
        const data = await response.json();
        this.overconsumedSeats = data.overconsumed_seats || 0;
        this.updateBannerState(data.low_balance, this.overconsumedSeats);
      }
    } catch (error) { }
  }

  updateBannerState(showBanner, overconsumedSeats = 0) {
    if (this.hasLowSeatsBannerTarget) {
      this.lowSeatsBannerTarget.classList.toggle('d-none', !showBanner);
    }
    if (this.hasSeatsLeftTarget) {
      this.seatsLeftTarget.textContent = this.totalSeatsValue || 0;
    }
    if (this.hasProgressBarTarget) {
      const remainingSeats = this.totalSeatsValue || 0;
      const total = remainingSeats + overconsumedSeats;
      const progressPercentage = total > 0 ? (remainingSeats / total) * 100 : 0;
      this.progressBarTarget.style.width = `${progressPercentage}%`;
      this.progressBarTarget.setAttribute('aria-valuenow', progressPercentage);
    }
    const assignBtn = $('.course-assign-btn');
    if (assignBtn.length) {
      assignBtn.prop('disabled', showBanner).toggleClass('disabled bg-secondary', showBanner);
    }
  }
}
